import { Col, Row } from 'reactstrap'
import '../../utils/prototype'
import ChatAvatar from '../../shared/image/ChatAvatar'

const StickyHeader = ({ userInfo, handleHeaderClick }: any) => {
  const isOnline = userInfo?.status === 'online'

  return (
    <div className="meetzy-main">
      <div className="messages">
        <div className="contact-details">
          <Row>
            <Col xs="5">
              <div className="d-flex left gap-2">
                <div className="media-right"></div>
                <div className="media-left cursor-pointer" onClick={() => handleHeaderClick(userInfo?.chat_id)}>
                  <div className={`profileInfo ${isOnline ? 'online' : 'offline'} menu-trigger`}>
                    <ChatAvatar
                      height={42}
                      width={42}
                      data={{
                        avatar: userInfo?.avatar,
                      }}
                      name={{ name: userInfo?.name?.firstTwoWords() }}
                      customClass="user-info avatar-sm"
                    />
                  </div>
                </div>
                <div className="flex-grow-1 cursor-pointer" onClick={() => handleHeaderClick(userInfo?.chat_id)}>
                  <h5>{userInfo?.name?.firstTwoWords() || 'Friend'}</h5>
                  {/* <p>{memberSubtitle}</p> */}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default StickyHeader
